import type { ReactNode } from 'react';
import { SupportButton } from './SupportButton';
import { UserMenu } from './UserMenu';
import logo from '../images/XilrtiX-header-logo.svg';
import '../styles/header.scss';

export function HeaderNav({ children }: { children?: ReactNode }) {
  return (
    <div className="x5-header__inner">
      <a className="x5-header__brand" href="/">
        <img alt="XiltriX" src={logo} width="118" height="36" />
      </a>
      {children && <div className="x5-header__slot">{children}</div>}
      {/* Before the account menu rather than inside it: reaching support has to
          be one click from an active session, and it is the only control here
          that can vanish at runtime. */}
      <SupportButton />
      {/* Replaces the react-bootstrap NavDropdown, which rendered the raw
          username as a caret menu. The account menu owns its own popover so it
          can carry the identity block and organization row. */}
      <UserMenu />
    </div>
  );
}
